import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { ChangeEvent, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "src/redux/slices/userSlice";
import { getOrgs } from "src/types/Organizations";
import {
  jobTypes,
  reportStatus,
  scheduleStatus,
} from "src/types/ScheduleJobStatus";
import { formatDateStr } from "src/utils/DateUtil";
import filterComponentStyles from "./FilterComponent.module.css";

interface FilterInterface {
  Mode: string;
  usersList?: Set<string>;
  filterData: any;
  handleOnBack: (filterReportRecords: any) => void;
}
const FilterComponent = ({
  Mode,
  usersList,
  filterData,
  handleOnBack,
}: FilterInterface) => {
  const [filterReportRecords, setFilterReportRecords] = useState<any>({
    ...filterData,
  });
  const user = useSelector(selectUser);
  const defaulttabledata: any = {
    productCode: user.productCode,
    clientCode: user.selectedClient ?? user.clientCode,
  };

  const initialData = () => {
    let initialData = { ...defaulttabledata };
    if (user.role === "USER") {
      initialData.reportUser = user.userId;
    }
    return initialData;
  };

  const [initialDefaultData, setInitialDefaultData] =
    useState<any>(initialData);

  const [clearTriger, setclearTriger] = useState<boolean>(
    filterData?.scheduleJobId ? true : false
  );
  const [applybutton, setapplybutton] = useState<boolean>(false);

  const handleapplyfilterfn = () => {
    setclearTriger(true);
    handleOnBack(filterReportRecords);
  };
  const handleremovefilters = () => {
    setclearTriger(!clearTriger);
    setapplybutton(false);
    setFilterReportRecords(initialDefaultData);
    handleOnBack(initialDefaultData);
  };

  return (
    <>
      <Box className={filterComponentStyles.filtersOuterBox}>
        {Mode === "ReportsScreen" && (
          <TextField
            placeholder="Enter Run Id"
            size="small"
            id="RunID"
            value={
              filterReportRecords.runId && filterReportRecords.runId !== null
                ? filterReportRecords.runId
                : ""
            }
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setFilterReportRecords({
                ...filterReportRecords,
                runId: parseInt(e.target.value) || null,
              });

              setclearTriger(true);
              setapplybutton(true);
            }}
            sx={{
              width: "21%",
              minWidth: "10rem",
              marginBottom: "4px",
            }}
          />
        )}
        <TextField
          placeholder="Schedule Job Id"
          size="small"
          id="scheduleJobId"
          value={
            Mode === "ReportsScreen"
              ? filterReportRecords.scheduleJobId !== undefined
                ? filterReportRecords.scheduleJobId
                : ""
              : filterReportRecords.userSpecificScheduleJobId &&
                  filterReportRecords.userSpecificScheduleJobId !== null
                ? filterReportRecords.userSpecificScheduleJobId
                : ""
          }
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFilterReportRecords({
              ...filterReportRecords,
              ...(Mode === "ReportsScreen"
                ? { scheduleJobId: parseInt(e.target.value) || null }
                : {
                    userSpecificScheduleJobId: parseInt(e.target.value) || null,
                  }),
            });
            setclearTriger(true);
            setapplybutton(true);
          }}
          sx={{
            width: "15%",
            minWidth: "10rem",
            marginBottom: "4px",
          }}
        />
        {Mode === "ScheduleScreen" && (
          <FormControl
            sx={{
              width: "15%",
              minWidth: "10rem",
            }}
          >
            <Select
              required
              id="frequencyrepeatson"
              size="small"
              value={
                filterReportRecords.jobType ? filterReportRecords.jobType : ""
              }
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                "& .MuiSelect-root": {
                  alignSelf: "flex-start",
                },
              }}
              onChange={(e) => {
                setFilterReportRecords({
                  ...filterReportRecords,
                  jobType: e.target.value,
                });
                setclearTriger(true);
                setapplybutton(true);
              }}
              displayEmpty
              renderValue={(value) =>
                value !== "" ? (
                  value
                ) : (
                  <span style={{ color: "#ACAFAE" }}>Frequency</span>
                )
              }
            >
              {jobTypes.map((org) => (
                <MenuItem
                  key={org}
                  value={org}
                >
                  {org}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <FormControl className={filterComponentStyles.formControlCss}>
          <Select
            className={filterComponentStyles.selectComponentCss}
            required
            size="small"
            id="status"
            value={filterReportRecords.status ? filterReportRecords.status : ""}
            sx={{
              "& .MuiSelect-root": {
                alignSelf: "flex-start",
              },
            }}
            onChange={(e) => {
              setFilterReportRecords({
                ...filterReportRecords,
                status: e.target.value,
              });
              setclearTriger(true);
              setapplybutton(true);
            }}
            displayEmpty
            renderValue={(value) =>
              value && value !== "" ? (
                value
              ) : (
                <span style={{ color: "#ACAFAE" }}>Status</span>
              )
            }
          >
            {Mode === "ReportsScreen"
              ? reportStatus.map((org) => (
                  <MenuItem
                    key={org}
                    value={org}
                  >
                    {org}
                  </MenuItem>
                ))
              : scheduleStatus.map((org) => (
                  <MenuItem
                    key={org}
                    value={org}
                  >
                    {org}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>

        <FormControl className={filterComponentStyles.formControlCss}>
          <Select
            className={filterComponentStyles.selectComponentCss}
            required
            id="countrycode"
            size="small"
            value={
              filterReportRecords.countryCode
                ? filterReportRecords.countryCode
                : ""
            }
            sx={{
              "& .MuiSelect-root": {
                alignSelf: "flex-start",
              },
            }}
            onChange={(e) => {
              setFilterReportRecords({
                ...filterReportRecords,
                countryCode: e.target.value,
              });
              setclearTriger(true);
              setapplybutton(true);
            }}
            displayEmpty
            renderValue={(value) =>
              value && value !== "" ? (
                value
              ) : (
                <span style={{ color: "#ACAFAE" }}>Organization</span>
              )
            }
          >
            {getOrgs(user.productCode).map((org) => (
              <MenuItem
                key={org}
                value={org}
              >
                {org}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {usersList && (
          <FormControl className={filterComponentStyles.formControlCss}>
            <Select
              className={filterComponentStyles.selectComponentCss}
              required
              size="small"
              id="reportUser"
              value={
                filterReportRecords.reportUser
                  ? filterReportRecords.reportUser
                  : ""
              }
              sx={{
                "& .MuiSelect-root": {
                  alignSelf: "flex-start",
                },
              }}
              onChange={(e) => {
                setFilterReportRecords({
                  ...filterReportRecords,
                  reportUser: e.target.value,
                });
                setclearTriger(true);
                setapplybutton(true);
              }}
              displayEmpty
              renderValue={(value) =>
                value && value !== "" ? (
                  value
                ) : (
                  <span style={{ color: "#ACAFAE" }}>
                    {Mode === "ReportsScreen" ? "Executed By" : "Scheduled By"}
                  </span>
                )
              }
            >
              {usersList.size > 0 ? (
                Array.from(usersList).map((user: any) => (
                  <MenuItem
                    key={user}
                    value={user}
                  >
                    {user}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Users</MenuItem>
              )}
            </Select>
          </FormControl>
        )}

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            className={filterComponentStyles.dateTimePickerCss}
            slotProps={{
              textField: { placeholder: "Job Start Date" },
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: "40px",
              },
            }}
            ampm={false}
            value={
              Mode === "ReportsScreen"
                ? filterReportRecords.reportStartDate
                  ? dayjs(filterReportRecords.reportStartDate)
                  : null
                : filterReportRecords.scheduleJobStartDateTime
                  ? dayjs(filterReportRecords.scheduleJobStartDateTime)
                  : null
            }
            onChange={(date: dayjs.Dayjs | null) => {
              if (Mode === "ReportsScreen") {
                setFilterReportRecords({
                  ...filterReportRecords,
                  reportStartDate: date
                    ? formatDateStr(date.toDate(), "YYYY-MM-DD HH:mm:ss", true)
                    : null,
                });
              } else {
                setFilterReportRecords({
                  ...filterReportRecords,
                  scheduleJobStartDateTime: date
                    ? formatDateStr(date.toDate(), "YYYY-MM-DD HH:mm:ss", true)
                    : null,
                });
              }
              setclearTriger(true);
              setapplybutton(true);
            }}
          />
          <DateTimePicker
            className={filterComponentStyles.dateTimePickerCss}
            slotProps={{
              textField: { placeholder: "Job End Date" },
            }}
            value={
              Mode === "ReportsScreen"
                ? filterReportRecords.reportEndDate
                  ? dayjs(filterReportRecords.reportEndDate)
                  : null
                : filterReportRecords.scheduleJobEndDate
                  ? dayjs(filterReportRecords.scheduleJobEndDate)
                  : null
            }
            sx={{
              // width: "22%",
              // minWidth: "10rem",
              "& .MuiInputBase-root": {
                height: "40px",
              },
            }}
            ampm={false}
            onChange={(date: dayjs.Dayjs | null) => {
              setFilterReportRecords({
                ...filterReportRecords,
                ...(Mode === "ReportsScreen"
                  ? {
                      reportEndDate: date
                        ? formatDateStr(
                            date.toDate(),
                            "YYYY-MM-DD HH:mm:ss",
                            true
                          )
                        : null,
                    }
                  : {
                      scheduleJobEndDate: date
                        ? formatDateStr(
                            date.toDate(),
                            "YYYY-MM-DD HH:mm:ss",
                            true
                          )
                        : null,
                    }),
              });
              setclearTriger(true);
              setapplybutton(true);
            }}
          />
        </LocalizationProvider>
      </Box>
      <Box className={filterComponentStyles.buttonsOuterBox}>
        <Button
          variant="outlined"
          size="small"
          disabled={!applybutton}
          onClick={handleapplyfilterfn}
          startIcon={<FilterAltIcon />}
        >
          Apply
        </Button>
        <Button
          variant="outlined"
          size="small"
          disabled={!clearTriger}
          onClick={handleremovefilters}
          sx={{
            ml: 2,
          }}
          startIcon={<FilterAltOffIcon />}
        >
          Clear
        </Button>
      </Box>
    </>
  );
};

export default FilterComponent;
